import React from 'react';

interface ViewIconProps {
    className?: string;
}

const ViewIcon: React.FC<ViewIconProps> = ({ className = "w-4 h-4" }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
        <rect x="3" y="4" width="8" height="6" rx="1"></rect>
        <rect x="13" y="4" width="8" height="6" rx="1"></rect>
        <rect x="3" y="14" width="8" height="6" rx="1"></rect>
        <rect x="13" y="14" width="8" height="6" rx="1"></rect>
    </svg>
);

export default ViewIcon;
